export default {
  overview: {
    title: "[[hwr.pl]] Abrechnen",
    subtitle: "Wählen Sie ein Projekt und einen Zeitraum aus, um [[hwr.pl]] anzuzeigen und abzurechnen",
    card: {
      info: {
        title: "Projekt",
        timeline: "Dauer",
        start_date: "Montage Beginn",
        end_date: "Geplantes Projektende",
        address: "Adresse",
        no_address: "Keine Adressdaten gepflegt",
        leading_users: "Leitende Mitarbeiter",
        no_leading_users: "Keine Leitenden Mitarbeiter gepflegt",
      },
      filter: {
        title: "Filter",
        start_date_range: "Zeitraum",
        active_range: "Ausgewählter Zeitraum",
        submit: "Suche",
        start_date_help: {
          title: "Erklärung der Kalendar Farben",
          red: "Rot: Einer oder mehrere Berichte sind vorhanden für den Tag. Keiner ist abgerechnet.",
          yellow:
            "Gelb: Einer oder mehrere Berichte sind vorhanden für den Tag. Nicht alle sind abgerechnet (z.B. 2/3 abgerechnet).",
          green: "Grün: Einer oder mehrere Berichte sind vorhanden für den Tag. Alle sind abgerechnet.",
          white: "Weiß: Keine Berichte vorhanden für den Tag.",
        },
      },
      result: {
        title: "[[hwr.pl]]",
        selected: "Ausgewählte",
        bill: "Abrechnen",
        loading: "[[hwr.pl]] werden geladen...",
        reports_found: "Bericht gefunden",
        reports_found_plural: "Berichte gefunden",
        steps: {
          step1_title: "Projekt auswählen",
          step1_description: "Wählen Sie ein Projekt aus dem Projektauswahl",
          step2_title: "Zeitraum auswählen",
          step2_description: "Wählen Sie einen Zeitraum zur Filterung der [[hwr.pl]]",
          step3_title: "Berichte suchen",
          step3_description: "Klicken Sie auf die Suchschaltfläche, um Ergebnisse anzuzeigen",
        },
        mark: {
          title: "Markierte",
          all: "Alle",
          unbilled: "Nicht Abgerechnete",
          none: "Keine",
        },
        manual_bill: "Manuell Abrechnen",
        again_bill: "Erneut Abrechnen",
        bill_exists: "Abgerechnet",
        draft_exists: "Abgerechnungsentwurf erstellt",
        bill_not_exists: "Noch nicht abgerechnet",
        no_categories: "Nicht gesetzt",
        table: {
          number: "Kennung",
          description: "Beschreibung",
          start_date: "Ausführungsdatum",
          categories: "Kategorien",
          billed: "Abgerechnet",
        },
      },
      bill: {
        title: "Abrechnung erstellen",
        subtitle: "Rechnung für ausgewählte Berichte erstellen",
        // Letzte Möglichkeit, wenn ein Druck ohne benennbare Verletzung fehlschlägt (Serverfehler,
        // abgebrochene Verbindung). Der Dialog ist die einzige Stelle, an der der Fehler erscheint —
        // er darf nie leer bleiben.
        failed: "Die Abrechnung konnte nicht erstellt werden. Bitte erneut versuchen.",
        warning: {
          notPrintedTitle: "Berichte noch nicht gedruckt mit Kennung",
          alreadyBilledTitle: "Berichte bereits abgerechnet mit Kennung",
          notPrinted: "Report Nr. <strong>{value}</strong> wurde noch nicht gedruckt",
          alreadyBilled: "Report Nr. <strong>{value}</strong> wurde bereits abgerechnet",
        },
        problem: {
          title: "Abrechnung nicht möglich",
          subtitle:
            "Für die folgenden Einträge fehlt ein Preis. Solange einer davon offen ist, kann keine Abrechnung erstellt werden.",
          checking: "Preise werden geprüft ...",
          fix: "Beheben",
          open: "Öffnen",
          failed: "Der Preis konnte nicht gespeichert werden.",
          hourly_rate: "Stundensatz",
          purchase_price: "Einkaufspreis",
          real_price: "Realpreis",
          selling_price: "Verkaufspreis",
          scope_project: "Gilt nur für dieses Projekt.",
          scope_selling: "Festpreis in diesem Projekt. 0 heißt ohne Berechnung.",
          scope_masterdata: "Wird in den Stammdaten gespeichert und gilt damit für alle Projekte.",
        },
        options: {
          title: "Abrechnungsoptionen",
          draft: "Entwurf",
          draft_description: "Als Entwurf speichern ohne zu finalisieren",
          hideProjectNumber: "Abrechnungsnummer Ausblenden",
          hideProjectNumber_description: "Projektnummer auf Rechnung ausblenden",
          customNumber: "Eigene Abrechnungsnummer vergeben",
          customNumber_description:
            "Ersetzt die fortlaufende Nummer auf der Rechnung und im Dateinamen. Die Zählung im Projekt läuft normal weiter.",
          customNumber_field: "Abrechnungsnummer",
          hideCreatedAtDate: "Druckdatum Ausblenden",
          hideCreatedAtDate_description: "Erstellungsdatum auf Rechnung ausblenden",
        },
        create: "Abrechnung erstellen",
      },
    },
  },
}
